<template>
  <div>
    <right-banner-template :title="title">
      <div class="quality-content" v-for="(qlt, i) in $store.getters['about/finalQuality']" :key="i">
        <p v-html="qlt.content"></p>
        <div class="temp">
          <div class="img-container">
            <img @contextmenu.prevent :src="require(`../../assets/quality/${qlt.certificate1}`)">
            <img @contextmenu.prevent :src="require(`../../assets/quality/${qlt.certificate2}`)">
          </div>
        </div>
      </div>
    </right-banner-template>
  </div>
</template>

<script>
export default {
  props: ['title']
}
</script>

<style scoped>
  /* .quality-content {
    padding: 10px 15px;
    width: 100%;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.23);
  }

  .title-container {
    position: relative;
  }

  .quality-content h3{
    margin-bottom: 30px;
    font-weight: bold;
    color: #007ab1;
  }

  #line {
    position: absolute;
    top: -12px;
    left: 330px;
  } */

  .quality-content p {
    font-size: 16px;
    line-height: 1.3;
  }

  .quality-content p br {
    margin-bottom: 10px;
  }

  .img-container {
    margin: 40px 0px;
    display: flex;
    justify-content: space-between;
    padding: 0px 60px;
  }

  .img-container img {
    border: 1px solid #dddddd;
  }

  @media (max-width: 870px) {
    .img-container {
      flex-direction: column;
      row-gap: 20px;
    }

    .img-container img {
      max-width: 300px;
      max-height: 420px;
    }

    .temp {
      display: flex;
      justify-content: center;
    }
  }

  @media (max-width: 450px) {
    .img-container {
      padding: 0px 10px;
    }
  }

  @media (max-width: 350px) {
    .img-container img {
      max-width: 250px;
      max-height: 370px;
    }
  }
</style>
